import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import MultiLanguageCodeBlock from 'common/developers/docs/widget/MultiLanguageCodeBlock';
import MobileWebViewSnippet from 'common/developers/docs/widget/snippets/MobileWebViewSnippet';
import WidgetDocsWarning from 'common/developers/docs/widget/WidgetDocsWarning';
import WidgetDocsMobileHelmet from 'common/helmets/WidgetDocsMobileHelmet';
import Link from 'common/Link';
import BoardPicker from 'common/subdomain/admin/BoardPicker';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/widget/_WidgetDocsMobile.scss';

class WidgetDocsMobile extends Component {
  static propTypes = {
    company: PropTypes.shape({
      boards: PropTypes.array,
    }),
  };

  state = {
    board: null,
  };

  onBoardSelected = (board) => {
    this.setState({
      board,
    });
  };

  render() {
    const { company } = this.props;
    const boards = company ? company.boards : null;
    const { board } = this.state;

    const subdomainURL =
      company && company.subdomain ? (
        <Link to="/">{'https://' + company.subdomain + '.canny.io'}</Link>
      ) : (
        'your-company.canny.io'
      );

    return (
      <div className="widgetDocsMobile">
        <WidgetDocsMobileHelmet />
        <WidgetDocsWarning />
        <div className="title">Mobile&nbsp;Widget</div>
        <div className="intro">
          These are instructions on how to put Canny's widget into your mobile&nbsp;app.
        </div>
        <ol className="numberedList">
          <li>
            <div className="subheading">1. Create a&nbsp;WebView</div>
            <div className="contents">Note: For iOS, you'll need to use a WKWebView.</div>
            <div className="contents">Load the following&nbsp;URL:</div>
            {boards ? (
              <BoardPicker
                boards={boards}
                placeholder="Fill in board token for:"
                onBoardSelected={this.onBoardSelected}
              />
            ) : (
              <div className="contents">
                <span className="bold">To find your board token</span>, log in above and select your
                board from the&nbsp;dropdown.
              </div>
            )}
            <div className="contents">
              <MultiLanguageCodeBlock
                blocks={[
                  {
                    code: board
                      ? MobileWebViewSnippet.replace('YOUR_BOARD_TOKEN', board.token)
                      : MobileWebViewSnippet,
                    language: 'http',
                  },
                ]}
                showSelector={false}
              />
            </div>
            <div className="contents">
              You should now be able to open the widget in your app.&nbsp;😃
            </div>
            <div className="contents">
              Optionally, you can include the <span className="code">theme</span> parameter to
              specify the theme (options are light [default], dark, auto).
            </div>
          </li>
          <li>
            <div className="subheading">
              2. Configure the <span className="code">ssoToken</span> parameter for
              Single&nbsp;Sign-On
            </div>
            <div className="contents">
              Single Sign-On connects the widget to your existing user accounts. This provides a
              more seamless experience for your users. It also lets you know exactly who is posting
              and&nbsp;voting.
            </div>
            <div className="contents">
              Follow our <Link to="/install/widget/sso">Setup Single Sign-On</Link> guide to
              generate SSO tokens on your&nbsp;server.
            </div>
            <div className="contents">
              The mobile widget only works with SSO, so if you aren't planning on using it then link
              users to {subdomainURL}&nbsp;instead.
            </div>
          </li>
          <li>
            <div className="subheading">Questions</div>
            <div className="contents">
              If you have any questions or issues, email us at{' '}
              <a href="mailto:support@canny.io">support@canny.io</a> and we'll get back to
              you&nbsp;ASAP.
            </div>
          </li>
        </ol>
      </div>
    );
  }
}

export default compose(withContexts({ company: DevelopersCompanyContext }), hot)(WidgetDocsMobile);
